import script from "./TempMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TempMenu.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=423cd01c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423cd01c"]])

export default __exports__